module.exports = __webpack_public_path__ + "static/media/ASingleShardJacket.5cb250f5.jpg";